export const COMMON_REDUX_STORE_INITIALISE = 'COMMON_REDUX_STORE_INITIALISE';
export const COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS = 'COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS';
export const COMMON_REDUX_STORE_CLEAR = 'COMMON_REDUX_STORE_CLEAR';
export const COMMON_REDUX_STORE_UPDATE_FROM_BACKEND = 'COMMON_REDUX_STORE_UPDATE_FROM_BACKEND';
